import React, { useEffect, useRef, useState } from 'react';
import './Loader.css';

import logo from '../assets/logo_paa.png';
import bee from '../assets/bee.png';

const Loader = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [visible, setVisible] = useState(true);

  const beeRef = useRef(null);
  const maskPathRef = useRef(null);
  const animationRef = useRef(null);

  const angleToSun = 35; 
  const waggleDancePath = "M 200 320 C 240 300 160 260 200 240 C 240 220 160 180 200 160 C 240 140 160 100 200 80 A 100 120 0 1 1 200 320 C 240 300 160 260 200 240 C 240 220 160 180 200 160 C 240 140 160 100 200 80 A 100 120 0 1 0 200 320";

  useEffect(() => {
    const maskPath = maskPathRef.current;
    const beeEl = beeRef.current;
    if (!maskPath || !beeEl) return;

    const length = maskPath.getTotalLength();
    maskPath.style.strokeDasharray = length;
    maskPath.style.strokeDashoffset = length;

    let start = null;
    const duration = 2500; 
    const cx = 200;
    const cy = 200;

    const animate = (time) => {
      if (!start) start = time;
      const progress = ((time - start) % duration) / duration;
      const draw = length * progress;

      maskPath.style.strokeDashoffset = length - draw;

      const point = maskPath.getPointAtLength(draw);
      const prevPoint = maskPath.getPointAtLength(Math.max(0, draw - 0.5));
      const nextPoint = maskPath.getPointAtLength(Math.min(length, draw + 0.5));
      const baseAngle = Math.atan2(nextPoint.y - prevPoint.y, nextPoint.x - prevPoint.x) * (180 / Math.PI);

      const rad = (angleToSun * Math.PI) / 180;
      const cos = Math.cos(rad);
      const sin = Math.sin(rad);

      const rotatedX = (cos * (point.x - cx)) - (sin * (point.y - cy)) + cx;
      const rotatedY = (sin * (point.x - cx)) + (cos * (point.y - cy)) + cy;

      beeEl.style.left = `${(rotatedX / 400) * 100}%`;
      beeEl.style.top = `${(rotatedY / 400) * 100}%`;
      beeEl.style.transform = `translate(-50%, -50%) rotate(${baseAngle + angleToSun + 90}deg)`;

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    const fade = setTimeout(() => setFadeOut(true), 3000); 
    const remove = setTimeout(() => setVisible(false), 4000);

    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
      clearTimeout(fade);
      clearTimeout(remove);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className={`loader-container ${fadeOut ? 'fade-out' : ''}`}>
      <div className="logo-wrapper">
        <svg className="bee-svg" viewBox="0 0 400 400">
          <g transform={`rotate(${angleToSun}, 200, 200)`}>
            <defs>
              <mask id="drawing-mask-final">
                <path ref={maskPathRef} d={waggleDancePath} fill="none" stroke="white" strokeWidth="20" strokeLinecap="round" />
              </mask>
            </defs>
            {/* Trayectoria con clases CSS para el tema */}
            <path 
              d={waggleDancePath} 
              fill="none" 
              className="bee-trail"
              strokeWidth="2" 
              strokeDasharray="4 6" 
              strokeLinecap="round" 
              mask="url(#drawing-mask-final)" 
            />
            <circle cx="200" cy="80" r="3" className="bee-dot" />
            <circle cx="200" cy="320" r="3" className="bee-dot" />
          </g>
        </svg>
        <div className="logo-mask">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="bee" ref={beeRef}>
          <img src={bee} alt="bee" />
        </div>
      </div>
    </div>
  );
};

export default Loader;